import { InfoOutlined } from '@mui/icons-material';
import { Box, Container, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { fullCenter } from '../Pages/Main/constants';
import Button from '../Components/Button';

function disableScroll() {
    try {
        document.body.style.overflow = 'hidden';
    } catch { }
}

function enableScroll() {
    try {
        document.body.style.overflow = '';
    } catch { }
}


export default function Dialog({ dialog, setDialog }) {
    const [value, setValue] = useState("");

    useEffect(() => {
        if (dialog) {
            disableScroll();
        } else {
            enableScroll();
        }
    }, [dialog])

    if (!dialog) {
        return <></>;
    }

    if (dialog.isInput) {
        return <Box sx={{ position: 'fixed', zIndex: "999999", width: '100vw', height: '100vh', top: 0, left: 0, bgcolor: 'rgba(0,0,0,0.3)', ...fullCenter }} onClick={() => {
            if (dialog.forced) return;
            setDialog(false);
        }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '400px', borderRadius: '12px', bgcolor: 'white', minHeight: '180px', maxHeight: '80vh', overflowY: 'auto' }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                <InfoOutlined sx={{ color: "#ff8000", height: '34px', width: '34px', mx: 'auto', mt: '24px' }} />
                <Typography variant="list_title" sx={{ maxWidth: '360px', mx: 'auto', my: 'auto', px: '24px', pt: '18px', pb: '24px', textAlign: 'center', color: '#6C7278', ...(dialog.sx || {}) }}>{dialog?.in || dialog}</Typography>
                <Box sx={{ ...fullCenter }}>
                    <TextField
                        sx={{ maxWidth: '240px', mb: '24px' }}
                        fullWidth
                        autoFocus
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                    />
                </Box>

                {dialog?.end || <></>}
                <Button text="Potvrdit" sx={{ width: 'auto', mt: 'auto', mb: '24px', mx: '24px' }} onClick={() => {
                    setDialog(null);
                    if (dialog?.onAccept) {
                        dialog.onAccept(value);
                    }
                }} />
            </Box>
        </Box>
    }

    return (
        <Box sx={{ position: 'fixed', zIndex: "999999", width: '100vw', height: '100vh', top: 0, left: 0, bgcolor: 'rgba(0,0,0,0.3)', ...fullCenter }} onClick={() => {
            if (dialog.forced) return;
            setDialog(false);
        }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '400px', borderRadius: '12px', bgcolor: 'white', minHeight: '180px', maxHeight: '80vh', overflowY: 'auto' }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                <InfoOutlined sx={{ color: "#ff8000", height: '34px', width: '34px', mx: 'auto', mt: '24px' }} />
                <Typography variant="list_title" sx={{ maxWidth: '360px', mx: 'auto', my: 'auto', px: '24px', pt: '18px', pb: '24px', textAlign: 'center', color: '#6C7278', ...(dialog.sx || {}) }}>{dialog?.in || dialog}</Typography>
                {dialog?.end || <></>}
                {dialog?.onAccept && <Button text="Potvrdit" sx={{ width: 'auto', mt: 'auto', mb: '24px', mx: '24px' }} onClick={() => {
                    setDialog(null);
                    if (dialog?.onAccept) {
                        dialog.onAccept();
                    }
                }} />}
            </Box>
        </Box>
    )
}
